import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[appCmsHost]',
})
export class LnCmsElementsDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
